// extracted by mini-css-extract-plugin
export default {"footer--pin":"Footer_footer--pin__xegsS","footer-image":"Footer_footer-image__ht6e5"};